export default {
  TAB_DETAIL: 'introduceId',
  TAB_NOTICE: 'noticeId',
  TAB_COMMENT: 'commentId',
  TAB_PRODUCT: 'productId'
}
